import { AppStateFailure, IStateSlice } from '@symphony-solo/shared/common-state/src';
import { TermsAndConditionsResponse } from '../models';

export class TermsAndConditionsState implements IStateSlice {
  public isLoading: boolean;
  public failures: AppStateFailure;
  public termsAndConditionsContent: Array<TermsAndConditionsResponse>;
  public faqContent: Array<TermsAndConditionsResponse>;
  public privacyPolicyContent: Array<TermsAndConditionsResponse>;

  constructor() {
    this.termsAndConditionsContent = null;
    this.faqContent = null;
    this.privacyPolicyContent = null;
    this.isLoading = false;
    this.failures = null;
  }
}
